import { assetsFormatter } from 'formatters'
import { Typography } from '@mui/material'

const GridFooterTotalAssets = (_props) => {
  const { totalStudents = 0, totalAssets = 0 } = _props
  return (
    <div className="flex flex-row w-full justify-between items-center bg-gray1 py-grid rounded-md">
      <Typography
        variant="h4"
        component="div"
        className="flex flex-row flex-grow px-grid"
      >
        <strong>
          Total: {totalStudents} {totalStudents > 1 ? 'Alumnos/as' : 'Alumno/a'}
        </strong>
      </Typography>
      <Typography
        variant="h4"
        component="div"
        className="flex flex-row flex-shrink-0 min-w-[270px] px-grid"
      >
        <strong>{assetsFormatter(totalAssets)}</strong>
      </Typography>
    </div>
  )
}

export default GridFooterTotalAssets
